/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Delete_ConfirmInputs */

const en_admin_roles_delete_confirm = /** @type {(inputs: Admin_Roles_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this role? This will deactivate it.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete this role? This will deactivate it." |
*
* @param {Admin_Roles_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_delete_confirm = /** @type {((inputs?: Admin_Roles_Delete_ConfirmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Delete_ConfirmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_delete_confirm(inputs)
});
export { admin_roles_delete_confirm as "admin.roles.delete_confirm" }